<!--
 * @Author: your name
 * @Date: 2019-06-17 14:39:27
 * @LastEditTime: 2020-09-17 15:04:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-module/packages/components/page/page.vue
-->
<template>
  <div :class="prefixCls">
    <Page
      v-if="total"
      :current.sync="pagenum"
      :total="total"
      :page-size="pageSize"
      @on-change="changePage"
      size="small"
      :show-elevator="elevator"
    />
  </div>
</template>

<script>
const prefixCls = 'zPage'
export default {
  name: 'ZPage',
  model: {
    prop: 'pageNum',
    event: 'changePageNum',
  },
  data() {
    return {
      prefixCls: prefixCls,
      pagenum: 1,
    }
  },
  props: {
    elevator: {
      type: Boolean,
      defalut: true,
    },
    total: {
      type: Number,
      defalut: 0,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    pageNum: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    changePage(page) {
      this.$emit('changePageNum', page)
    },
  },
  watch: {
    pageNum() {
      this.pagenum = this.pageNum
    },
  },
}
</script>
